<template>
    <div >
        <Breadtabsheader/>
        <div class="h-content">
            <!-- 搜素条件 -->
            <div class="h-piece">
                <div class="h-content paddingtopcls">
                    <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;margin-top: 30px;">
                        <h1>引入评估</h1>
                    </div>
                    <div>
                        <table style ="border-collapse: collapse;width:80%; margin-bottom: 20px ;margin-top: 20px;margin-left: 60px;" cellspacing =0 border="1">
                            <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                <td style="width: 100px" rowspan = "3"><img
                                        src="../../../../public/assets/images/flow/agent_score.png" height="32" width="108"/></td>
                                <td style="width: 180px" colspan = "2" rowspan = "3" class="title">海尔生物医疗经销商引入评估</td>
                                <td style="width: 100px" >编号：GNSCB-02-F01</td>
                            </tr>
                            <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                <td style="width: 100px">版本：B</td>
                            </tr>
                            <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                <td style="width: 100px">页次：1/1</td>
                            </tr>
                            <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                <td style="width: 100px" colspan = "4" class="subheading">基础信息</td>
                            </tr>
                            <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                <td style="width: 100px">区    域 </td>
                                <td style="width: 180px">{{bscUserInfoAgent.areaname}}</td>
                                <td style="width: 100px">申请日期</td>
                                <td style="width: 100px">{{bscUserInfoAgent.creationDate}}</td>
                            </tr>
                            <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                <td style="width: 100px">公司名称</td>
                                <td style="width: 180px">{{bscUserInfoAgent.username}}</td>
                                <td style="width: 100px">法人代表</td>
                                <td style="width: 100px">{{bscUserInfoAgent.legal}}</td>
                            </tr>
                            <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                <td style="width: 100px">对接人</td>
                                <td style="width: 180px">{{bscUserInfoAgent.name1}}</td>
                                <td style="width: 100px">联系电话</td>
                                <td style="width: 100px">{{bscUserInfoAgent.contactmobilephone}}</td>
                            </tr>
                            <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                <td style="width: 100px">对阵地市（个数）</td>
                                <td style="width: 180px">{{bscUserInfoAgent.againstAreaCount}}</td>
                                <td style="width: 100px">对阵用户（个数）</td>
                                <td style="width: 100px">{{bscUserInfoAgent.againstUserCount}}</td>
                            </tr>
                            <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                <td style="width: 100px" colspan = "4" class="subheading">引入评估项目</td>
                            </tr>
                            <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                <td style="width: 100px" class="subheading">评估项目</td>
                                <td style="width: 180px" class="subheading">项目描述</td>
                                <td style="width: 100px" class="subheading">见证资料（附件为必传项）</td>
                                <td style="width: 100px" class="subheading">合格/不合格</td>
                            </tr>
                            <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                <td style="width: 100px">人员配置</td>
                                <td style="width: 180px">员工6名以上，一线销售人员3名以上</td>
                                <td style="width: 100px">提供公司缴纳社保人员数量</td>
                                <td style="width: 100px">
                                    <el-select v-model="bscUserInfoAgent.staffing" placeholder="请选择" disabled class="select" style="width:100px;border: none;box-shadow: none">
                                        <el-option label="合格" value="1"></el-option>
                                        <el-option label="不合格" value="2"></el-option>
                                    </el-select>
                                </td>
                            </tr>
                            <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                <td style="width: 100px">公司规模</td>
                                <td style="width: 180px">上年度销售业绩：A类区域≥1200万，B类区域≥1000万，C类区域≥600万</td>
                                <td style="width: 100px">提供上年度审计表</td>
                                <td style="width: 100px">
                                    <el-select v-model="bscUserInfoAgent.scale" placeholder="请选择" disabled style="width:100px;">
                                        <el-option label="合格" value="1"></el-option>
                                        <el-option label="不合格" value="2"></el-option>
                                    </el-select>
                                </td>
                            </tr>
                            <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                <td style="width: 100px">经营资质</td>
                                <td style="width: 180px">临床检验分析仪器、二类6858-3、6853-4、11-01、22-14、22-15、22-16三类6854-1、22-16</td>
                                <td style="width: 100px">提供营业执照、经营许可证</td>
                                <td style="width: 100px">
                                    <el-select v-model="bscUserInfoAgent.qualification"  placeholder="请选择" disabled style="width:100px">
                                        <el-option label="合格" value="1"></el-option>
                                        <el-option label="不合格" value="2"></el-option>
                                    </el-select>
                                </td>
                            </tr>
                            <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                <td style="width: 100px">品牌能力</td>
                                <td style="width: 180px">同行业相关产品的代理授权书或证书</td>
                                <td style="width: 100px">提供同行业品牌授权文件</td>
                                <td style="width: 100px">
                                    <el-select v-model="bscUserInfoAgent.brandPower" placeholder="请选择" disabled style="width:100px">
                                        <el-option label="合格" value="1"></el-option>
                                        <el-option label="不合格" value="2"></el-option>
                                    </el-select>
                                </td>
                            </tr>
                            <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                <td style="width: 100px">业务能力</td>
                                <td style="width: 180px">近两年中标业绩证明或合同证明10份以上，或用户合同规模≥600万</td>
                                <td style="width: 100px">提供合同或业绩证明文件</td>
                                <td style="width: 100px">
                                    <el-select v-model="bscUserInfoAgent.businessPower" disabled placeholder="请选择" style="width:100px">
                                        <el-option label="合格" value="1"></el-option>
                                        <el-option label="不合格" value="2"></el-option>
                                    </el-select>
                                </td>
                            </tr>
                            <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                <td style="width: 100px" class="subheading">结论</td>
                                <td style="width: 180px" colspan="3">{{bscUserInfoAgent.conclusion}}</td>
                            </tr>
                            <tr style="background-color: White; text-align: center; color:black;height:30px;" v-if="!isQualified">
                                <!--                  <td style="width: 100px" class="subheading">结论</td>-->
                                <!--                  <td style="width: 180px" >{{bscUserInfoAgent.conclusion}}</td>-->
                                <td style="width: 100px" class="subheading">申请请示报告</td>
                                <td style="width: 100px" colspan="3">
                                    <brupload
                                            :refid="refid"
                                            reftype="申请请示报告"
                                            uploadflag
                                            delflag
                                            :before-upload="beforeUpload"
                                            :showtime="false"
                                    >
                                    </brupload>
                                </td>
                            </tr>
                            <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                <td style="width: 100px" class="subheading">网络运营经理确认</td>
                                <td style="width: 180px">{{bscUserInfoAgent.quyuConfirm}}</td>
                                <td style="width: 100px" class="subheading">省区经理确认</td>
                                <td style="width: 100px" colspan="2">{{bscUserInfoAgent.daquConfirm}}</td>
                            </tr>
                        </table>
                        <div class="h-pieceIn2">
                            <div class="h-pieceTitle2" style="margin:0 0 20px 0;">
                                <h1>上传附件</h1>
                            </div>
                            <div style="font-size: 0.15rem;color: #ff2424;margin-bottom: 0.2rem">*
                                上传文件格式只能是 JPG或PNG或PDF 格式! 文件大小不能超过 5M!
                            </div>
                            <div class="h-formLine">
                                <div class="h-pieceCon2 weekplandetail30">
                                    <el-form :model="bscUserInfoAgent"
                                             ref="formLabelAlign1i"
                                             :inline="true" :rules="rules" style="margin-left: 100px">
                                        <el-form-item label="公司缴纳社保人员数量" class="h-elformWrap-2" prop="upload1">
                                            <brupload
                                                    :refid="refid"
                                                    reftype="公司缴纳社保人员数量"
                                                    :uploadflag="false"
                                                    :delflag="false"
                                                    :before-upload="beforeUpload"
                                                    :showtime="false"
                                                    :tpFlag = 'true'
                                            >
                                            </brupload>
                                        </el-form-item>
                                        <el-form-item label="上年度审计表" class="h-elformWrap-2" prop="upload2" style="margin-left: 180px">
                                            <brupload
                                                    :refid="refid"
                                                    reftype="公司资产负债表"
                                                    :uploadflag="false"
                                                    :delflag="false"
                                                    :before-upload="beforeUpload"
                                                    :showtime="false"
                                                    :tpFlag = 'true'
                                            >
                                            </brupload>
                                        </el-form-item>
                                        <br>
                                        <el-form-item label="同行业品牌授权文件" class="h-elformWrap-2" prop="upload3">
                                            <brupload
                                                    :refid="refid"
                                                    reftype="同行业品牌授权文件"
                                                    :uploadflag="false"
                                                    :delflag="false"
                                                    :before-upload="beforeUpload"
                                                    :showtime="false"
                                                    :tpFlag = 'true'
                                            >
                                            </brupload>
                                        </el-form-item>
                                        <el-form-item label="合同或业绩证明文件" class="h-elformWrap-2" prop="upload4"  style="margin-left: 180px">
                                            <brupload
                                                    :refid="refid"
                                                    reftype="合同或业绩证明文件"
                                                    :uploadflag="false"
                                                    :delflag="false"
                                                    :before-upload="beforeUpload"
                                                    :showtime="false"
                                                    :tpFlag = 'true'
                                            >
                                            </brupload>
                                        </el-form-item>
                                        <br>
                                        <el-form-item label="二类备案表" class="h-elformWrap-2" prop="upload5">
                                            <brupload
                                                    :refid="refid"
                                                    reftype="二类备案表"
                                                    :uploadflag="false"
                                                    :delflag="false"
                                                    :before-upload="beforeUpload"
                                                    :showtime="false"
                                                    :tpFlag = 'true'
                                            >
                                            </brupload>
                                        </el-form-item>
                                        <el-form-item label="三类医疗器械许可证" class="h-elformWrap-2" prop="upload6"  style="margin-left: 180px">
                                            <brupload
                                                    :refid="refid"
                                                    reftype="三类医疗器械许可证"
                                                    :uploadflag="false"
                                                    :delflag="false"
                                                    :before-upload="beforeUpload"
                                                    :showtime="false"
                                                    :tpFlag = 'true'
                                            >
                                            </brupload>
                                        </el-form-item>
                                    </el-form>
                                </div>
                            </div>
                        </div>

                        <div class="h-table h-mrt30    bbbb">
                            <div class="h-pieceTitle2 hang">
                                <h1 class="h1">审批意见</h1>
                                <el-form :model="bscUserInfoAgent" label-position="right" :inline="true"
                                         class="demo-ruleForm h-formbLine ">
                                    <el-form-item label="审批意见" class="h-elformWrap-2 newBox"
                                                  style="width: 100%!important;">
                                        <el-input v-model="bscUserInfoAgent.auditMind2" placeholder="请输入"
                                        ></el-input>
                                    </el-form-item>
                                </el-form>

                            </div>
                        </div>
                        <div class="center" style="margin-left: 300px;margin-top: 50px">
                            <el-row>
                                <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">返回</el-button>
                                <el-button class="h-btn h-bBtn h-bgred" @click="pass(2)">驳回</el-button>
                                <el-button class="h-btn h-bBtn h-bggreen" @click="pass(1)">通过</el-button>
                                <el-button class="h-btn h-bBtn" @click="findDetail">跟踪</el-button>
                                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                           @click="choose1">导出Excel
                                </el-button>
                            </el-row>
                        </div>
                        <div style="height: 50px">   <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/> </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from "../../../api/SystemService";
    import scoretablesp from '../../../components/score/scoreShenPi'
    import updownfile from "../../../utils/updownfile";
    export default {
        components:{scoretablesp},
        data(){
          return{
              instid:null,
              usercodeInfo:null,
              showTaskList:false,
              usercode:"",
              bscUserInfoAgent:{
                  usercode:"",
                  customerName1:"",
                  staffing:"",
                  scale:"",
                  qualification:"",
                  brandPower:"",
                  businessPower:"",
                  conclusion:"",
                  daquConfirm:"",
                  quyuConfirm:"",

                  areaname:"",
                  creationDate:"",
                  username:"",
                  legal:"",
                  name1:"",
                  contactmobilephone:"",
                  showscoretable:true,
                  refid:"",
                  againstAreaCount:"",
                  againstUserCount:"",
                  field:"2",
              },
              refid: null,
              guancha:false,
              isQualified:false,
              showhistory:false,
              field:2,//2生命科学1医疗创新
              inst:{
                  daqu:"",
                  quyu:"",
              },
              rules: {
                  upload1:
                      [
                          {required: true, message: '请上传资料', trigger: 'blur'},
                      ],
                  upload2:
                      [
                          {required: true, message: '请上传资料', trigger: 'blur'},
                      ],
                  upload3:
                      [
                          {required: true, message: '请上传资料', trigger: 'blur'},
                      ],
                  upload4:
                      [
                          {required: true, message: '请上传资料', trigger: 'blur'},
                      ],
                  upload5:
                      [
                          {required: true, message: '请上传资料', trigger: 'blur'},
                      ],
                  upload6:
                      [
                          {required: true, message: '请上传资料', trigger: 'blur'},
                      ],
              },
          };
        },
        methods: {
            choose1() {
                updownfile.down('/api/swyl/v1/agent/bscUserInfoAgent/getExcel',this.bscUserInfoAgent,"post");
            },
            beforeUpload(file){
                const isFile = file.type === 'image/jpg'||file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf';
                const isLt5M = file.size / 1024 / 1024 < 5;
                console.log(isFile,file.type)

                if (!isFile) {
                    this.$message.error('上传文件的格式只能是 JPG或PNG或PDF 格式!');
                    return false;
                }
                if (!isLt5M) {
                    this.$message.error('上传文件的大小不能超过 5M!');
                    return false;
                }
            },
            getConclusion(){
                if(this.bscUserInfoAgent.staffing == 1 &&
                    this.bscUserInfoAgent.scale == 1 &&
                    this.bscUserInfoAgent.qualification == 1 &&
                    this.bscUserInfoAgent.brandPower == 1 &&
                    this.bscUserInfoAgent.businessPower == 1
                ){
                    this.bscUserInfoAgent.conclusion = "合格";
                    this.isQualified = true;
                }else {
                    this.bscUserInfoAgent.conclusion = "不合格";
                    this.isQualified = false;
                }
            },
            pass(aaa){
                let query = {
                    taskid:this.$route.query.taskid,
                    aaa:aaa,
                    auditMind2:this.bscUserInfoAgent.auditMind2,
                    usercode: this.bscUserInfoAgent.usercode,
                    instid:this.$route.query.instid,
                    ywid:this.$route.query.ywid,
                }
                ss.SignService.scorePass(query).then(res =>{
                    this.$msg.alerts("提交成功！", () => {
                        //刷新右上角的代办个数
                        this.$store.dispatch("searchTasktotal")
                        //跳转回系统的代办列表
                        this.$router.push({
                            path: '/personal/dealCenter'
                        })
                    })
                })
            },
            //查看审批流详情
            findDetail() {
                this.showhistory = true;
                //进行强制数据渲染
                this.$forceUpdate();
            },
            cancel(){
                this.$router.push({
                    path: '/agent/agentCopy'
                })
            },
        },
        created(){
            this.instid = this.$route.query.instid;

            ss.SignService.selectScoreByInstid(this.instid)
                .then(res =>{
                    console.log("11111",res)
                    this.bscUserInfoAgent.usercode= res.msg.usercodeInfo;
                    this.bscUserInfoAgent.customerName1= res.msg.customerName1Bas;
                    this.bscUserInfoAgent.staffing= res.msg.staffingSco;
                    this.bscUserInfoAgent.scale= res.msg.scaleSco;
                    this.bscUserInfoAgent.qualification= res.msg.qualificationSco;
                    this.bscUserInfoAgent.brandPower= res.msg.brandPowerSco;
                    this.bscUserInfoAgent.businessPower= res.msg.businessPowerSco;
                    this.bscUserInfoAgent.conclusion= res.msg.conclusionSco;
                    this.bscUserInfoAgent.daquConfirm= res.msg.daquConfirmSco;
                    this.bscUserInfoAgent.quyuConfirm= res.msg.quyuConfirmSco;
                    this.bscUserInfoAgent.status= res.msg.statusSco;
                    this.bscUserInfoAgent.instid= res.msg.instidSco;

                    this.bscUserInfoAgent.areaname= res.msg.areanameInfo;
                    this.bscUserInfoAgent.creationDate= res.msg.creationDateBas;
                    this.bscUserInfoAgent.username= res.msg.usernameInfo;
                    this.bscUserInfoAgent.legal= res.msg.legalBas;
                    this.bscUserInfoAgent.name1= res.msg.name1Bas;
                    this.bscUserInfoAgent.contactmobilephone= res.msg.contactmobilephoneBas;
                    this.refid = res.msg.fileidInfo;
                    this.bscUserInfoAgent.refid = res.msg.fileidInfo;
                    this.bscUserInfoAgent.field = 2
                    this.getConclusion();
                })
        },
    }

</script>
